module.exports = __webpack_public_path__ + "img/1-03.050ea31a.jpg";